import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { Country } from '@app/entities/models/geography/country.model';
import { GeographicalBoundary } from '@app/entities/models/geography/geography.model';
import { PhonePrefix } from '@app/entities/models/geography/phone-prefix.model';
import { StreetType } from '@app/entities/models/geography/street-type-model';

export interface GeographyRepository {
  getCountries(): Observable<Country[]>;
  getPostalCodes(countryIsoNumericCode: string, alternativeCode: string): Observable<string[]>;
  getStreetTypes(): Observable<StreetType[]>;
  getPhonePrefixes(): Observable<PhonePrefix[]>;
  getGeographicalBoundaries(
    countryIsoNumericCode: string,
    alternativeCode?: string,
    parentTypeId?: string
  ): Observable<GeographicalBoundary[]>;
}

export const GEOGRAPHY_REPOSITORY = new InjectionToken<GeographyRepository>('GEOGRAPHY_REPOSITORY');
